<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <h4>Assign Users to Whatsapp Group ({{ chatRegistrationsOutstanding }})</h4>
      </v-col>
    </v-row>
    <v-container fluid v-if="$apollo.queries.whatsappGroups.loading">
      <v-col></v-col>
    </v-container>
    <v-container fluid v-else>
      <v-row>
        <v-col>
          <v-select v-model="workoutBlockId" :items="workoutBlockOptions" placeholder="Select Workout Block" />
        </v-col>
      </v-row>
      <v-row v-if="whatsappGroups">
        <v-col cols="5">
          <v-card>
            <v-card-title>
              Available Whatsapp Groups
            </v-card-title>
            <v-card-text>
              <v-simple-table>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Block</th>
                    <th>Av. Age</th>
                    <th>Av. Eng.</th>
                    <th>Num Users</th>
                    <th>Max Users</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="group in whatsappGroups" :key="'tb-' + group.id">
                    <td>{{ group.title }}</td>
                    <td>{{ group.workoutBlock.title }}</td>
                    <td>{{ group.averageAge }}</td>
                    <td>{{ group.averageEngagement }}</td>
                    <td>{{ group.chatregistrationSet.edges.length }}</td>
                    <td>{{ group.maxUsers }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="7">
          <v-progress-linear v-if="$apollo.queries.chatRegistrations.loading" :indeterminate="true" />
          <div v-if="chatRegistrations">
            <v-alert v-if="assigned" type="success" dismissible>Users Assigned</v-alert>
            <div class="text-right mb-5">
              <v-btn @click="assignUsers">Assign Users &amp; Send Email Invite</v-btn>
            </div>
            <v-simple-table>
              <thead>
                <tr>
                  <th>User</th>
                  <th>Age</th>
                  <th>Engagement Score</th>
                  <th>Active Blocks</th>
                  <th>Whatsapp Group</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="registration in chatRegistrations" :key="registration.id">
                  <td>{{ registration.user.firstName + " " + registration.user.lastName }}</td>
                  <td>{{ registration.user.userProfile.age }}</td>
                  <td>{{ registration.user.userProfile.engagementScore }}</td>
                  <td>{{ registration.user.userProfile.currentBlocks.map((element) => element.title).join(", ") }}</td>
                  <td>
                    <v-select
                      :items="whatsappGroupOptions"
                      :value="registration.whatsappGroup ? registration.whatsappGroup.id : null"
                      @input="(value) => updateUserWhatsappGroup(registration.id, value)"
                    />
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { ASSIGN_USERS_TO_WHATSAPP_GROUPS_MUTATION, WHATSAPP_GROUPS_QUERY } from "@/constants/graphql/accountability/accountability";
import { WORKOUT_BLOCKS_NODE_QUERY } from "@/constants/graphql/blocks/workoutblocks";
import { CHAT_REGISTRATIONS_QUERY, CHAT_REGISTRATIONS_OUTSTANDING_QUERY } from "@/constants/graphql/chat/chat";

import { extractNodes } from "@/lib/array";
import { decodeId } from "@/lib/string";

export default {
  name: "AssignUsersToAccountabilityGroup",
  data() {
    return {
      assigned: false,
      workoutBlockId: null,
      assignments: [],
    };
  },
  computed: {
    workoutBlockOptions() {
      if (!this.workoutBlocks?.edges) return [];
      return this.workoutBlocks.edges.map((element) => {
        return {
          text: element.node.title,
          value: element.node.id,
        };
      });
    },
    whatsappGroupOptions() {
      let options = this.whatsappGroups.map((element) => {
        return {
          text: element.title,
          value: element.id,
        };
      });
      options.unshift({
        text: "Unassigned",
        value: null,
      });
      return options;
    },
  },
  methods: {
    assignUsers() {
      const data = this.assignments.map((element) => {
        return {
          chatRegistrationId: decodeId(element.chatRegistrationId),
          whatsappGroupId: element.whatsappGroupId,
        };
      });
      this.$apollo.mutate({
        mutation: ASSIGN_USERS_TO_WHATSAPP_GROUPS_MUTATION,
        variables: {
          registrations: data,
        },
        refetchQueries: ["chatRegistrationsOutstanding", "chatRegistrations", "whatsappGroups"],
      });

      this.assigned = true;
    },
    updateUserWhatsappGroup(registrationId, whatsappGroupId) {
      let assignment = {
        chatRegistrationId: registrationId,
        whatsappGroupId: whatsappGroupId,
      };

      let existing = this.assignments.findIndex((element) => element.chatRegistrationId == registrationId);
      if (existing > -1) {
        this.assignments[existing] = assignment;
      } else {
        this.assignments.push(assignment);
      }
    },
  },
  apollo: {
    workoutBlocks: {
      query: WORKOUT_BLOCKS_NODE_QUERY,
      variables() {
        return {
          showAccountabilityGroupRegistration: true,
          withUsers: false,
        };
      },
      fetchPolicy: "network-only",
    },
    whatsappGroups: {
      query: WHATSAPP_GROUPS_QUERY,
      fetchPolicy: "network-only",
      variables() {
        return {
          showAll: false,
          workoutBlockId: decodeId(this.workoutBlockId),
        };
      },
      skip() {
        return !this.workoutBlockId;
      },
    },
    chatRegistrations: {
      query: CHAT_REGISTRATIONS_QUERY,
      fetchPolicy: "network-only",
      variables() {
        return {
          workoutBlockId: this.workoutBlockId,
          whatsappGroup_Id_Isnull: true,
        };
      },
      skip() {
        return !this.workoutBlockId;
      },
      update(data) {
        return extractNodes(data.chatRegistrations.edges);
      },
    },
    chatRegistrationsOutstanding: {
      query: CHAT_REGISTRATIONS_OUTSTANDING_QUERY,
      fetchPolicy: "network-only",
    },
  },
};
</script>
